

// ROUTE constants
export const ROUTES = {
  DASHBOARD: "dashboard",
  REPORTS: "reports",
  DOCTORRETENSION: "doctorretension",
  DOWNLOADEXCEL: "downloadexcel",
  TRENDS: "trends",
  LOGIN: "login",
  ONBOARDING_STATISTICS: "onboarding_statistics",
  MR_ANALYSIS: "mr_analysis",
  SALES_DASHBOARD: "sales_dashboard",

};

// Color constants

export const COLOR = {
  PRIMARYCOLOR: "#FF835B",

}

// Set the CSS variable dynamically
document.documentElement.style.setProperty('--primary-color', COLOR.PRIMARYCOLOR);

export const STRINGS = {
  login: {
    title: "Login",
    emailPlaceholder: "Enter your email",
    otpPlaceholder: "Enter OTP",
    sendOtp: "Send OTP",
    login: "Login",
    invalidEmail: "Invalid email address.",
  },
  sidebar: {
    dashboard: "Dashboard",
    onboardingStatistics: "Onboarding Statistics",
    doctorRetention: "Doctor Retention",
    trendsData: "Trends Data",
    downloadExcel: "Download Excel",
    report: "Report",
    logout: "Logout",
    mrAnalysis: "MR Analysis",
    sales_dashboard:" Sales Dashboard",
  },
  dashboard: {
    selectJointType: "Select Joint Type",
    all: "All",
    back: "Back",
    neck: "Neck",
    knee: "Knee",
    startDate: "Start Date",
    endDate: "End Date",
    startDateError: "Start date cannot be greater than the end date.",
    totalUsers: "Title",
    totalPatients: "Total number of patients",
    reportedPain: "People who reported pain 2 or more ",
    avgPainReported: "Average pain reported",
    peopleImproved: "People improved",
    avgPainImproved: "Average Pain Reported by Improved Users",
    latestPain: "People with latest pain 0,1,2 -Constant & Worsened",
    totalUsersImproved: "Total users improved",
    totalImprovementPercentage: "Total improvement percentge",
    title: "Title",
    avgPainOnboarded: "Average Pain Reported by Onboarded Users",
    reportedPainOnboarded: "People who reported pain 2 or more ",
    avgPainOnboardedMultiple: "Average pain reported",
    peopleImprovedOnboarded: "People improved",
    avgPainImprovedOnboarded: "Average Pain Reported by Improved Users",
    latestPainOnboarded: "People with latest pain 0,1,2 -Constant & Worsened",
    totalUsersImprovedOnboarded: "Total users improved",
    improvedOnboardedPercentage: "Total improvement percentge",
    totalPatientsExercise: "Total number of patients",
    avgPainExercise: "Average Pain Reported by Onboarded Users",
    reportedPainExercise: "People who reported pain 2 or more ",
    avgPainExerciseMultiple: "Average pain reported",
    peopleImprovedExercise: "People improved",
    avgPainImprovedExercise: "Average Pain Reported by Improved Users",
    latestPainExercise: "People with latest pain 0,1,2 -Constant & Worsened",
    totalUsersImprovedExercise: "Total users improved",
    improvedExercisePercentage: "Total improvement percentge",
    initialPain: "Initial Pain",
    painReductionAvg: "Pain reduction average",
    painReducedPercentage: "% pain reduced",
    totalUsersTab: "Total Users",
    onboardingCompletedTab: "Onboarding Completed",
    performedAtLeastOneExerciseTab: "Performed At Least One Exercise",
  },
  onboardingStatistics: {
    title: "Onboarding Statistics Dashboard",
    search: "Search",
    startDate: "Start Date",
    endDate: "End Date",
    table1Title: "Table - Patients who have not filled up the first questions",
    table2Title: "Table - Patients who got their exercise plan",
    lowerBack: "Lower Back",
    neck: "Neck",
    knee: "Knee",
    patientNotCompleted: "Patient who has not completed the first question",
    total: "Total",
    pain1: "Pain 1",
    pain2: "Pain 2",
  },
  pdf: {
    progressReport: "Progress Report",
    till: "till",
    overallImpact: "Overall Impact",
    nearly: "Nearly",
    in10: "in 10",
    patientsReportedImprovement: "patients reported clinical improvement",
    exerciseAdherence: "(Exercise Adherence > 70%)",
    patientsFeltHappy: "patients felt happy after their exercise sessions",
    totalExercises: "Total number of exercises performed in MyFlexa",
  },
  downloadExcel: {
    startDateError: "Start date cannot be greater than the end date.",
    startDate: "Start Date",
    endDate: "End Date",
    downloadBtn: "Download Excel",
    enterPasswordMsg: "Please Enter password to download Excel sheet",
    passwordPlaceholder: "Please enter password",
    show: "Show",
    hide: "Hide",
  },
  reports: {
    generateReport: "Generate Report",
    generateReportWithSecureCode: "Generate Report with Secure Code",
    enterSecureCode: "Enter secure code",
  },
  mrAnalysis: {
    selectDoctor: "Select Doctor",
    selectDateRange: "Select Date Range",
    startDate: "Start Date",
    endDate: "End Date",
    generateReport: "Generate Report",
    doctorName: "Doctor Name",
    totalPatients: "Total Patients",
    averagePain: "Average Pain",
    painReduction: "Pain Reduction",
    reportGenerated: "Report Generated Successfully",
  }
};